<template>
    <div class="m-hero">
        <div class="title"></div>
        <div class="slogen"></div>

        <div class="m-skill">
            <div class="hero-name">
                <div class="u-btn u-player" @click="$video_modal()"></div>
            </div>

            <div class="gif-view">
                <img :src="skill_config[active].img">
            </div>

            <div class="skill-tab">
                <div class="tab-hd">
                    <div class="tab-item" :class="{'act' : active==index}" v-for="(item,index) in skill_config" :key="index" @click="active = index">
                        <div class="skill-icon"><img :src="item.icon" :alt="item.label"></div>
                        <div class="skill-label">{{ item.label }}</div>
                    </div>
                </div>

                <div class="tab-bd">
                    <h6>{{ skill_config[active].label }} <span class="name">{{ skill_config[active].skill_name }}</span></h6>

                    <div class="skill-text" v-html="skill_config[active].skill_text"></div>
                </div>
            </div>
        </div>

        <div class="layer-set"></div>
        <div class="layer-char"></div>        
    </div>
</template>

<style scoped>
.m-hero{
    max-width: 1920px;
    position: relative;
    margin: 30px auto 0;
}

.title{
    position: relative;
    width: 558px;
    height: 180px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/title-2.png);
    z-index: 3;
}

.slogen{
    position: relative;
    width: 853px;
    height: 57px;
    margin: -30px auto 15px;
    background-image: url(~@/assets/images/pc/slogen-2.png); 
    z-index: 3;  
}

.m-skill{
    position: relative;
    width: 1300px;
    margin: 110px auto 0;
    padding-left: 50px;
    z-index: 3;
}

.hero-name{
    position: relative;
    width: 249px;
    height: 121px;
    background-image: url(~@/assets/images/pc/hero-name.png);
}

.u-player{
    position: absolute;
    right: -80px;
    bottom: 0;
    width: 71px;
    height: 71px;
    background-image: url(~@/assets/images/pc/btn-player.png);
}

.gif-view{
    position: relative;
    width: 532px;
    height: 370px;
    background-image: url(~@/assets/images/pc/gif-view.png);
}

.gif-view img{
    position: absolute;
    left: 50%;
    top: 50%;
    width: 498px;
    height: 336px;
    transform: translate(-50%,-50%);
}

.gif-view::before{
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 500px;
    height: 339px;
    transform: translate(-50%,-50%);
    background-image: url(~@/assets/images/pc/gif-border.png);
    z-index: 3;
}

.tab-hd{
    display: flex;
    margin-top: 20px;
    margin-left: 18px;
}

.tab-hd .tab-item{
    cursor: pointer;
    transition: all .3s ease-in;
}

.tab-item.act,
.tab-hd .tab-item:hover{
    transform: translateY(-5px);
}

.skill-icon{
    position: relative;
    width: 81px;
    height: 81px;
    margin-right: 58px;
    background-color: #1e1e21;
    transition: all .3s ease-in;
}

.skill-icon img{
    position: absolute;
    left: 50%;
    top: 50%;
    width: 78px;
    height: 78px;
    transform: translate(-50%,-50%);
}

.tab-item.act .skill-icon::before,
.tab-item:hover .skill-icon::before{
    border-color: #1e231c;
}

.skill-icon::before{
    content: '';
    position: absolute;
    display: block;
    left: 50%;
    top: 50%;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 5px solid #bebbbb;
    transform: translate(-50%,-50%);
    transition: all .3s ease-in;
    z-index: 3;
}

.skill-label{
    width: 81px;
    margin-top: 7px;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    color: #f8f2d7;
    transition: all .3s ease-in;
}

.tab-item.act .skill-label,
.tab-item:hover .skill-label{
    color: #238f76;
}

.tab-bd{
    margin-top: 20px;
}

h6{
    margin-left: 18px;
    margin-bottom: 12px;
    font-size: 24px;
    color: #238f76;
}

h6 .name{
    padding-left: 7px;
    font-weight: 400;
}

.skill-text{
    width: 500px;
    height: 250px;
    margin-left: 18px;
    font-size: 16px;
    color: #c0c0c0;
    line-height: 2;
}

.layer-set{
    position: absolute;
    left: 0;
    top: 200px;
    width: 253px;
    height: 427px;
    background-image: url(~@/assets/images/pc/layer-set_1.png);
    pointer-events: none;
}

.layer-char{
    position: absolute;
    right: 0;
    top: 250px;
    width: 1136px;
    height: 1320px;
    background-image: url(~@/assets/images/pc/img-char.png);
    pointer-events: none;    
}
</style>

<script>
export default {
    data (){
        return {
            active : 0,
            skill_config : [
                {
                    label : 'W',
                    skill_name : '贵族气场',
                    skill_text : '肚皮鼓起前顶，对前方500范围内的敌人造成伤害</br>\
                                强化后：造成伤害的同时击退敌军一定距离</br>',
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/mls-W.gif',
                    icon : 'https://web-resource.17m3.com/m3guo/202207/version/skill/M365.png',
                },                {
                    label : 'E',
                    skill_name : '滚滚而来',
                    skill_text : '身体膨胀变大，如车轮向前滚动，移动速度提升至极限，持续6秒</br>\
                                期间可以点击鼠标移动控制转向，碰撞到敌方英雄后造成范围伤害和眩晕</br>\
                                碰撞到无法通行的地形或使用物品、技能会停止滚动</br>\
                                滚动期间不受减速效果影响</br>\
                                强化状态下滚动的路径上会燃起火焰，对敌人造成持续伤害并降低35%移动速度',
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/mls-E.gif',
                    icon : 'https://web-resource.17m3.com/m3guo/202207/version/skill/M366.png',
                },                {
                    label : 'R',
                    skill_name : '肥龙在天',
                    skill_text : '腾身而起，引导1.2秒后对目标区域的敌人造成伤害并击飞</br>\
                                引导期间自身处于无敌状态</br>\
                                强化状态下落地对区域内的敌方触发火焰冲击，降低50%生命回复效果。持续3秒',
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/mls-R.gif',
                    icon : 'https://web-resource.17m3.com/m3guo/202207/version/skill/M367.png',
                },                {
                    label : 'F',
                    skill_name : '神气十足',
                    skill_text : '释放体内的潜力，将内心的热情化作炙热火焰</br>\
                                减少自身所受到的伤害</br>\
                                普通攻击对敌方造成火焰伤害，持续3秒</br>\
                                强化其他技能的能力，持续12秒',
                    img : 'https://web-resource.17m3.com/m3guo/202207/version/mls-F.gif',
                    icon : 'https://web-resource.17m3.com/m3guo/202207/version/skill/M368.png',
                },
            ],
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/page/hero.vue